import React from 'react';
import { ToggleButton } from './toggle-button';
import styles from './cross-class-toggle.module.css';

interface CrossClassToggleProps extends React.ComponentProps<'div'> {
    crossClassOption: string;
    isCrossClass: boolean;
    setIsCrossClass: (value: boolean) => void;
}

/**
 * @deprecated No substitution... no longer used.
 *
 * TODO: remove this component
 */
export function CrossClassToggle({
    crossClassOption,
    isCrossClass,
    setIsCrossClass,
}: CrossClassToggleProps): React.JSX.Element {
    return (
        <ToggleButton
            onToggle={setIsCrossClass}
            options={[
                {
                    cssClasses: [styles['button'], styles['cross-class']],
                    label: 'X-Class',
                    value: true,
                },
                {
                    cssClasses: [styles['button'], styles['not-cross-class']],
                    label: crossClassOption,
                    value: false,
                },
            ]}
            state={isCrossClass}
            data-testid="EVENT_PANEL_NARRATIVE_TOGGLE"
            data-value={isCrossClass ? 'xclass' : 'singleclass'}
        />
    );
}
